import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-refresh',
  templateUrl: './modal-refresh.component.html',
  styleUrls: ['./modal-refresh.component.scss']
})
export class ModalRefreshComponent implements OnInit {

  filterForm = new FormGroup({
    tempo: new FormControl(600, Validators.required)
  })

  get tempo() { return this.filterForm.get('tempo').value; }

  textoCancelar = "Cancelar";
  textoOk = "OK";

  titulo = "Tempo de atualização (segundos)";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<any>
  ) {
    this.textoCancelar = data.textoCancelar || this.textoCancelar;
    this.textoOk = data.textoOk || this.textoOk;
    this.titulo = data.titulo || this.titulo;
  }

  confirm() {
    this.dialog.close({
      sucesso: true,
      tempo: this.tempo
    });
  }

  cancel() {
    this.dialog.close({
      sucesso: false
    });
  }  

  ngOnInit() { }

}
